<template>
  <BModal id="preferencesModal" v-model="modalVisible" title="My Preferences" @ok="savePreferences">
    <div class="input-group mb-3">
      <span class="input-group-text">Name</span>
      <input type="text" v-model="preferences.name" class="form-control" />
    </div>

    <div class="mb-3">
      <div class="mb-3" style="margin-top: 0.2em;">
        <div class="input-group">
          <label for="favoritePrecincts" class="input-group-text">Favorite Precincts:</label>
          <input type="text" v-model="newPrecinct" class="form-control" placeholder="Type a precinct to add it"
            @change="updateFavoritePrecincts" />
        </div>

        <div>
          <span v-for="(precinct, index) in preferences.favoritePrecincts" :key="index">
            <span class="badge bg-primary me-1" :class="{ 'flash-badge': flashingPrecinct === precinct }">
              {{ precinct }}
              <button type="button" class="btn-close btn-close-white" aria-label="Close"
                @click="removePrecinct(index)"></button>
            </span>
          </span>
        </div>
      </div>

      <div class="mb-3 input-group">
        <label for="colormap" class="input-group-text">Preferred Colormap:</label>
        <select id="colormap" v-model="preferences.colormap" class="form-select">
          <option value="Viridis">Viridis</option>
          <option value="Turbo">Turbo</option>
          <option value="Plasma">Plasma</option>
          <option value="Rainbow">Rainbow</option>
        </select>
      </div>
    </div>
    <div class="mb-3 form-check form-switch" style="vertical-align: middle;">
      <input class="form-check-input align-baseline" type="checkbox" id="darkModeSwitch" v-model="preferences.darkMode">
      <label class="form-check-label align-baseline" for="darkModeSwitch">{{ {
        true: "Dark", false:
          "Light"
      }[preferences.darkMode] }} Mode </label>
    </div>

    <template #footer>
      <span class="theme" title="❤️ Joe Biden!"
        :class="{ 'dark': preferences.darkMode, 'light': !preferences.darkMode }"></span>
      <div class="ms-auto">
        <BButton variant="secondary" @click="modalVisible = false">Close</BButton>
        <BButton variant="primary" @click="savePreferences">Save Preferences</BButton>
      </div>
    </template>
  </BModal>
</template>

<script>
import { updateProfile, getAuth, onAuthStateChanged } from 'firebase/auth';
import { BModal, BButton } from 'bootstrap-vue-next';
import { initializePreferences, preferences, savePreferences } from '@/components/userPreferences.js'; // Import
import { ref } from "vue";

export default {
  name: 'PreferencesModal',
  components: {
    BModal,
    BButton
  },
  props: ['contactId'],
  data() {
    return {
      auth: getAuth(),
      preferences: preferences,
      displayName: '',
      newPrecinct: ref(""),
      flashingPrecinct: null,
      modalVisible: false
    };
  },
  mounted() {
    initializePreferences()
    onAuthStateChanged(this.auth, (u) => {
      this.displayName = u?.displayName;
    });

  },
  methods: {
    show() {
      this.modalVisible = true;
    },
    savePreferences() {
      updateProfile(this.auth.currentUser, { displayName: this.displayName }); // Update display name
      savePreferences()
      this.modalVisible = false;
    },
    addPrecinct() {
      if (!(this.preferences.favoritePrecincts.includes(this.newPrecinct))) {
        this.preferences.favoritePrecincts.push(this.newPrecinct);
        this.newPrecinct = "";
      } else {
        this.flashPrecinct(this.newPrecinct);
      }
    },
    removePrecinct(index) {
      this.preferences.favoritePrecincts.splice(index, 1);
    },
    flashPrecinct(precinct) {
      this.flashingPrecinct = precinct;
      setTimeout(() => {
        this.flashingPrecinct = null;
      }, 500); // Adjust flash duration as needed
    }
  },
};
</script>

<style scoped>
.flash-badge {
  animation: flash 0.5s;
  /* Adjust animation duration as needed */
}

@keyframes flash {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}
</style>
